













import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'PopupRadio',
})
/**
 * @vuese
 * @group Atomic/Organisms
 * PopupHeader component
 */
export default class PopupRadio extends Vue {
  // [data]
  picked: string = 'business';
  // [method]

  @Watch('picked')
  checkRadio() {
      this.$emit("radioCheck", this.picked);
  }
}
